const customTimer = ({
  days,
  hours,
  minutes,
  seconds,
}: {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
}) => {
  const h = parseInt(hours, 10) > 0 ? `${hours}h` : '';
  const min = parseInt(minutes, 10) > 0 ? `${minutes}min` : '';
  const s = parseInt(seconds, 10) > 0 ? `${seconds}s` : '';
  const timeInHours = `${h} ${min} ${s}`;
  const timeInDays = `${days} días`;

  const expirationDateString =
    parseInt(days, 10) > 0 ? `${timeInDays} ${timeInHours}` : timeInHours;

  return expirationDateString;
};

export default customTimer;
